import type { SVGProps } from "react";

export const PartiallyCompleted = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.909 15.7556L19.1756 9.48889L17.9312 8.24445L12.909 13.2667L10.3756 10.7333L9.13118 11.9778L12.909 15.7556Z"
      fill={props.fill}
    />
    <path
      d="M14.1534 3C12.9183 3.02685 11.7536 3.2623 10.6594 3.70636C9.49471 4.179 8.48161 4.82043 7.62007 5.63067C6.75853 6.4409 6.07648 7.39367 5.57391 8.48899C5.07135 9.5843 4.82007 10.7546 4.82007 12C4.82007 13.2454 5.07135 14.4157 5.57391 15.511C6.07648 16.6063 6.75853 17.5591 7.62007 18.3693C8.48161 19.1796 9.49471 19.821 10.6594 20.2936C11.7536 20.7377 12.9183 20.9732 14.1534 21V19.1991C12.1194 19.1487 10.3883 18.452 8.96024 17.109C7.47648 15.7136 6.7346 14.0106 6.7346 12C6.7346 9.98942 7.47648 8.28643 8.96024 6.89103C10.3883 5.548 12.1194 4.85128 14.1534 4.80087V3Z"
      fill={props.fill}
    />
  </svg>
);
